import { render, staticRenderFns } from "./products-compositions-input.vue?vue&type=template&id=1d3a0000&"
import script from "./products-compositions-input.vue?vue&type=script&lang=js&"
export * from "./products-compositions-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports